import TextInput from "../../../../../shared/components/text-input/text-input";
import "./text-field-widget.scss";

export interface IFieldWidget {
  id: string;
  type: "field";
  modalType: "datamodelField" | "reference";
  label: string;
  required: boolean;
  readonly: boolean;
  primaryKey: boolean;
  datamodel_type: string;
  datamodel_id: string;
  field_id: string;
  textarea?: boolean;
  modalData?: { // Extra information the modal needs to edit this widget
    [index: string]: string;
  }
}

interface IFieldWdigetProps {
  widget: IFieldWidget;
  value: string | undefined;
  onChange?(newValue: string, key: string): void;
}

const FieldWidget = ({widget, value, onChange}: IFieldWdigetProps) => {
  const handleOnTextChange = (newValue: string) => {
    onChange?.(newValue, widget.id);
  };

  const renderField = () => {
    return <TextInput
      id={widget.id}
      key={widget.id}
      name={widget.id}
      type={widget.textarea ? "textarea" : widget.type}
      label={widget.label}
      required={widget.required}
      disabled={widget.readonly}
      inputKey={widget.id}
      handleOnChange={handleOnTextChange}
      value={value}
      controlled={true}
    />;
  };
  return <div className="textFieldWidget">
    {renderField()}
  </div>;
};

export default FieldWidget;